<template>
  <Row :gutter="32">
    <i-col :xs="12" v-if="hardwareData._id">
      <p>Existing f/w modules for {{hardwareData.ModuleName}} </p>
      <Table :height="300" :columns="firmwareColumns" :loading="dataLoading" :data="moduleFirmwares" class="table-hide-header" style="margin-top: 8px;"  :row-class-name="ModuleFirmwareRowClassName"  @on-row-click="onModuleFirmwareRowClick">
        <div slot-scope="{ row, index }" slot="FirmwareVersion">
          <span v-if="row.FirmwareVersion && row.FirmwareVersion!==0">V{{ row.FirmwareVersion}}</span>
          <span v-else>\Not Set</span>
        </div>
        <div slot-scope="{ row, index }" slot="FirmwareFileName">
          <span v-if="row.FirmwareFileName && row.FirmwareFileName!==0">{{ row.FirmwareFileName}}</span>
          <span v-else>\Not Set</span>
        </div>
        <div slot-scope="{ row, index }" slot="action">
          <Button type="error" size="small" @click="deleteModuleFirmware(row,index)">Delete</Button>
        </div>
      </Table>
      <Button long style="margin-top: 8px;"
              type="primary"
              :loading="submitLoading"
              @click="handleCreate()"
      >       <span v-if="!submitLoading">Add f/w module</span>
        <span v-else>Processing...</span>
      </Button>
    </i-col>
    <i-col :xs="12">
      <div class="add-form">
        <ModuleFirmwareForm ref="moduleFirmwareForm" @getFirmwares="getFirmwareModules" @setActive="setActive" :moduleFirmwares="moduleFirmwares" :hardwareData="hardwareData"></ModuleFirmwareForm>
      </div>
    </i-col>
  </Row>
</template>

<script>
  import { bus } from "../../main";
  import { addFirmware, deleteFirmware, getHardware } from "../../_services/firmware.service";
  import ModuleFirmwareForm from "./FirmwareForm"

  export default {
    data() {
      return {
        languages: [],
        selectedLanguage: null,
        activeModule:null,
        submitLoading:false,
        hardwareData:{},
        firmwareColumns: [
          {
            title: " ",
            slot: "FirmwareVersion",
          },
          {
            title: " ",
            slot: "FirmwareFileName",
            maxWidth:150,
          },
          {
            title: " ",
            slot: "action",
            width: 100,
            align: "right"
          }
        ],
        moduleFirmwares: [],
        dataLoading:true,
      };
    },
    components:{
      ModuleFirmwareForm
    },
    methods: {
      getFirmwareModules(data,update,firmwareData){
        if(data) {
          if(update) {
            this.activeModule = null
          }
          getHardware(data.hardware._id).then(hardwareData => {
            this.hardwareData = Object.assign({},hardwareData.data.data.hardware)
            this.moduleFirmwares = Object.assign([],hardwareData.data.data.firmwares)
            if(firmwareData){
              this.onModuleFirmwareRowClick(firmwareData)
            }
            this.dataLoading=false
          }).catch(err => {
            bus.$emit('requestError',err)
            this.submitLoading = false
            this.$Message.error('Failed to get firmwares. Please try again later.')
          })

        }else {
          this.hardwareData = {}
          this.moduleFirmwares = []
        }
      },
      handleCreate() {
        this.submitLoading=true
        let defaultFirmware={
          hardware:this.hardwareData._id,
          FirmwareVersion:1,
          Description:'',
        }
        addFirmware(defaultFirmware).then(async res => {
          this.$Message.success(`Firmware successfully added!`);
          await this.getFirmwareModules({hardware:this.hardwareData},null,res.data.data);
          this.submitLoading = false

        }).catch(err => {
          bus.$emit('requestError',err)
          this.submitLoading = false
          this.$Message.error('Failed to create firmware. Please try again later.')
        })
      },
      async onModuleFirmwareRowClick(firmwareData,index){
        if(this.activeModule===index){
          this.activeModule=null
          this.$refs.moduleFirmwareForm.resetForm()
        }else {
          if(firmwareData){
            let vIndex = this.moduleFirmwares.map(function(e) { return e._id; }).indexOf(firmwareData._id);
            if(vIndex===-1){
              this.activeModule = index
            }else {
              this.activeModule = await vIndex
            }
          }else {
            this.activeModule = index
          }
          let firmware=Object.assign({},firmwareData)
          this.$refs.moduleFirmwareForm.setUpdateData(firmware)
        }
      },
      ModuleFirmwareRowClassName(row, index) {
        if (index === this.activeModule) {
          return 'active-table-row';
        }
        return '';
      },
      async setActive(data){
        if(!data){
          this.activeModule=null
        }else{
          let vIndex = this.moduleFirmwares.map(function(e) { return e._id; }).indexOf(data._id);
          if(vIndex===-1){
            this.activeModule = null
          }else {
            this.activeModule = await vIndex
          }
        }
      },
      deleteModuleFirmware(data,index) {
        this.$Modal.confirm({
          title: 'Remove Firmware',
          content: "Are you sure you want to remove firmware?",
          okText: 'Remove',
          cancelText: 'Cancel',
          onOk: () => {
            this.dataLoading = true
            deleteFirmware(data._id).then(res => {
              this.moduleFirmwares.splice(index, 1);
              this.dataLoading = false
              this.$refs.moduleFirmwareForm.resetForm()
              this.$Message.success(`Successfully deleted firmware!`);
            }).catch(err => {
              this.dataLoading = false
              this.$Message.error(err.message);
            });
          },
        });
      },
    },
    mounted() {
      bus.$on('hardwareChanged', (data) => {
        this.dataLoading=true

        this.getFirmwareModules(data)
      });
    }
  };
</script>
<style scoped>
  .add-form{
    min-height: 300px;
  }
</style>
